import React, {useCallback, useEffect, useState} from 'react';
import {deformatPhoneNumber, formatPhoneNumber} from "utils/transformer.ts";
import Input from "components/atom/Input";


type PropsType = {
    onChange: (data: { clean: string, formatted: string }) => void,
    value: string,
    name: string,
    type: 'text' | 'phone' | 'email'
    label: string | React.ReactNode
    error?: string | null
    disabled?: boolean
}

function FormInputPhone(props: PropsType) {
    const {onChange, value = '', ...otherProps} = props
    const [inputValue, setInputValue] = useState<string>(formatPhoneNumber(value));
    const [cleanValue, setCleanValue] = useState<string>(deformatPhoneNumber(value));

    useEffect(() => {
        if (onChange) {
            onChange({
                formatted: inputValue,
                clean: cleanValue
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue])

    const handleInput = useCallback((e: any) => {
        setInputValue(formatPhoneNumber(e.target.value));
        setCleanValue(deformatPhoneNumber(e.target.value));
    }, [])

    return <Input {...otherProps}
                  formikField={false}
                  placeholder="(999) 999-999"
                  onChange={(e: any) => handleInput(e)}
                  value={inputValue}/>;
}

export default FormInputPhone
